import React from 'react';
import { useModalsContext, useStoreConfigContext } from '/src/providers';
import { Modal, H2, Form } from '/src/components';
import * as styles from './styles.scss';

const Success = ({ message }) => {
    const { translate } = useStoreConfigContext();
    const { hideModal } = useModalsContext();

    return (
        <Modal toggle={hideModal}>
            <H2>{translate('Success')}</H2>
            {
                !!message &&
                <div className={styles.message}>
                    {message}
                </div>
            }
            <Form.Column mt>
                <Form.Button onClick={hideModal}>
                    {translate('Close')}
                </Form.Button>
            </Form.Column>
        </Modal>
    );
};

export default Success;
